import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import classnames from 'classnames';
import { InputGroup, InputGroupAddon, InputGroupText, Input, Alert } from 'reactstrap';
import { connect } from 'react-redux';
import { Redirect, Link, useHistory, useParams } from 'react-router-dom';
import { updatePassword } from '../actions/formActions';

const NewResetPassword = ({ errors: propsErrors, auth, updatePassword }: any) => {
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [errors, setErrors] = useState<any>({});

  const history = useHistory();
  const { code, userid } = useParams<any>() as any;

  const prevErrorsRef = useRef(propsErrors);
  const prevPasswordUpdatedRef = useRef(auth.passwordUpdated);

  const onChange = (e) => {
    if (e.target.name === 'password1') setPassword1(e.target.value);
    if (e.target.name === 'password2') setPassword2(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const userData = { password1, password2 };
    const linkData = { code, userid };
    updatePassword(userData, linkData);
  };

  useEffect(() => {
    if (propsErrors !== prevErrorsRef.current) {
      prevErrorsRef.current = propsErrors;
      setErrors(propsErrors);
    }
    if (auth.passwordUpdated !== prevPasswordUpdatedRef.current && auth.passwordUpdated) {
      prevPasswordUpdatedRef.current = auth.passwordUpdated;
      setPassword1('');
      setPassword2('');
      setTimeout(() => {
        history.push('/login');
      }, 3000);
    }
  });

  if (localStorage.jwtToken) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <div className="container my-5 py-5" style={{ minHeight: '50vh' }}>
      <Helmet>
        <title>Reset Password - Frozberries Victoria</title>
        <meta name="description" content="Reset Password - Frozberries Victoria" />
      </Helmet>
      <div className="row">
        <div className="col-md-8 m-auto">
          <h1 className="display-4 text-center mb-5">Reset Password</h1>
          {auth.passwordUpdated && (
            <Alert color="success">
              Your password has been successfully updated. You are being redirected to the login
              page.
            </Alert>
          )}
          {errors.code && (
            <Alert color="danger">
              {errors.code} Click <Link to="/reset-password">here</Link>.
            </Alert>
          )}
          <form onSubmit={onSubmit}>
            <InputGroup className="my-2">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>@</InputGroupText>
              </InputGroupAddon>
              <Input
                type="password"
                placeholder="password"
                onChange={onChange}
                className={classnames('', { 'is-invalid': errors.password1 })}
                value={password1}
                name="password1"
                autoComplete="on"
              />
              <div className="invalid-feedback">{errors.password1}</div>
            </InputGroup>
            <InputGroup className="my-2">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>@</InputGroupText>
              </InputGroupAddon>
              <Input
                type="password"
                placeholder="confirm password"
                onChange={onChange}
                className={classnames('', { 'is-invalid': errors.password2 })}
                value={password2}
                name="password2"
                autoComplete="on"
              />
              <div className="invalid-feedback">{errors.password2}</div>
            </InputGroup>

            <input
              disabled={password1 === '' || password2 === '' ? true : false}
              type="submit"
              value="Update Password"
              className=" text-light btn-block mt-4 p-2 border-0"
              style={{ backgroundColor: 'rgb(236,23,79)' }}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  errors: state.errors,
  auth: state.form,
  cart: state.cart,
});

export default connect(mapStateToProps, { updatePassword })(NewResetPassword);
